// src/components/SocialLinks.js
import React from "react";
import InstagramIcon from "../icons/InstagramIcon";
import TwitterIcon from "../icons/TwitterIcon";
import FacebookIcon from "../icons/FacebookIcon";
import EmailIcon from "../icons/EmailIcon";
import LinkedInIcon from "../icons/LinkedInIcon";
import SnapchatIcon from "../icons/SnapchatIcon";
import TwitchIcon from "../icons/TwitchIcon";
import SoundCloudIcon from "../icons/SoundCloudIcon";
import BandcampIcon from "../icons/BandcampIcon";
import MediumIcon from "../icons/MediumIcon";
import WhatsAppIcon from "../icons/WhatsAppIcon";
import TwineIcon from "../icons/TwineIcon";
import YouTubeIcon from "../icons/YouTubeIcon";
import PinterestIcon from "../icons/PinterestIcon";
import GitHubIcon from "../icons/GitHubIcon";
import TikTokIcon from "../icons/TikTokIcon";

const SocialLinks = ({ links }) => {
  const renderIcon = (anchorText) => {
    switch (anchorText) {
      case "instagram":
        return <InstagramIcon />;
      case "x":
        return <TwitterIcon />;
      case "facebook":
        return <FacebookIcon />;
      case "tiktok":
        return <TikTokIcon />;
      case "email":
        return <EmailIcon />;
      case "linkedin":
        return <LinkedInIcon />;
      case "youtube":
        return <YouTubeIcon />;
      case "pinterest":
        return <PinterestIcon />;
      case "snapchat":
        return <SnapchatIcon />;
      case "twitch":
        return <TwitchIcon />;
      case "github":
        return <GitHubIcon />;
      case "soundcloud":
        return <SoundCloudIcon />;
      case "bandcamp":
        return <BandcampIcon />;
      case "medium":
        return <MediumIcon />;
      case "whatsapp":
        return <WhatsAppIcon />;
      case "twine":
        return <TwineIcon />;
      default:
        return null;
    }
  };

  return (
    <div className="social-links">
      {links.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {renderIcon(link.type)}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
